import React, { memo, useState, useEffect, useCallback, useRef, useImperativeHandle, forwardRef, ForwardedRef, useMemo } from 'react'
import { Column, ContainerService, DragRowMove, Editors, FieldType, Formatter, Formatters, GridMenuEventWithElementCallbackArgs, GridOption, OnActiveCellChangedEventArgs, OnBeforeEditCellEventArgs, OnCellChangeEventArgs, OnClickEventArgs, OnDragEventArgs, OnEventArgs, OnHeaderClickEventArgs, OnKeyDownEventArgs, OnRenderedEventArgs, OnRowsChangedEventArgs, OnSelectedRowsChangedEventArgs, PaginationService, SingleColumnSort, SlickCellSelectionModel, SlickDataView, SlickGrid, SlickRowSelectionModel, SlickgridReact, SlickgridReactInstance, TranslaterService, addWhiteSpaces } from 'slickgrid-react';
import i18next, { type TFunction } from 'i18next';
import { Translation, WithTranslation, withTranslation } from 'react-i18next';
import $ from 'jquery'
import { useMount, useSize, useWhyDidYouUpdate } from 'ahooks';
import { debounce, throttle } from 'lodash-es';
import { message, Modal, Spin } from 'antd';
import styles from './index.module.less'
import clsx from 'clsx';
import { SlickgridEditDisabledClassName } from '@/config/constant';
import { SlickgridReactProps } from 'slickgrid-react/dist/types/components/slickgridReactProps';
import { traverseTree } from '@/utils/tree';
import ReactDOMServer from 'react-dom/server';
import { ReactComponent as ExpandIcon } from '@/assets/svg/slickGridFold.svg';
import { isNumeric } from '@/utils/number';

interface Props extends Partial<SlickgridReactProps> {
  loading: boolean
  disabled?: boolean
  showLoading?: boolean
  treeExpandColumn?: string // 指定哪一列显示展开图标
  treeLevels?: { key: number | string, label: string }[] // 层级数组
  loadChildren?: (item: any) => Promise<any[]> // 加载子节点的回调函数‘
  expandAllLevel?: number // 展开全部子节点层级，用来控制展开全部
}

export interface SlickGridRef {
  reactGridInstance: SlickgridReactInstance | null;
  getReactGridInstance: () => SlickgridReactInstance | null;
  getActiveRowIndex: () => number | null;
  setActiveRowIndex: (rowIndex: number) => void;
  setActiveColumn: (columnIndex: number) => void;
  removeRowSelected: () => void;
  moveUp: () => void;
  moveDown: () => void;
  deleteRow: () => void;
  expandTree: (level: any) => void
  setCellDisabledStyle: ({ row, name, key }: { row: any, name: string, key: string }) => void
}

const SlickGridComponent = forwardRef<SlickGridRef, Props>((props: Props, ref) => {
  const { loading, gridId, disabled, showLoading = true, treeExpandColumn, treeLevels = [], loadChildren, expandAllLevel = 0 } = props
  const stateRef = useRef<{
    activeColumn: any,// 当前高亮列
    activeRowIndex: any, // 当前高亮行
    loadingNodes: Set<string | number>, // 正在加载的节点ID集合
  }>({ activeColumn: undefined, activeRowIndex: undefined, loadingNodes: new Set() })
  const setActiveColumn = (v: any) => stateRef.current.activeColumn = v
  const getActiveColumn = () => stateRef.current.activeColumn
  const setActiveRowIndex = (v: any) => stateRef.current.activeRowIndex = v
  const getActiveRowIndex = () => stateRef.current.activeRowIndex
  // grid 实例
  const reactGridRef = useRef<SlickgridReactInstance | null>(null)
  // grid 对象
  const reactGridObjRef = useRef<SlickGrid | null>(null)
  // grid 视图
  const reactGridDataviewRef = useRef<SlickDataView | null>(null)
  // const size = useSize(document.querySelector('body'));
  // gridwrap ref
  const tableWrapRef = useRef<HTMLDivElement>(null)
  const warpSize = useSize(tableWrapRef.current)
  const gridOptions: GridOption = {
    enableColumnReorder: false, // 禁用列交换
    showHeaderRow: false,
    enableExcelCopyBuffer: true,
    enableCellNavigation: true,
    autoCommitEdit: true, // 是否自动提交编辑
    editable: true, // 设置为 true 表示表格单元格可以被编辑。 设置为 true 表示可以使用键盘箭头键在单元格之间导航
    i18n: i18next,
    enableTranslate: true,
    // enableRowSelection: true, // 启用行选择
    // autoResize: {
    //     container: '#container',
    //     // bottomPadding: 8,
    //     // maxHeight: 600,
    //     calculateAvailableSizeBy: 'container'
    // },
    gridMenu: {
      hideToggleFilterCommand: true, // 隐藏过滤菜单命令
      hideClearAllSortingCommand: true // 隐藏清除排序菜单命令
    },
    ...props.gridOptions,
    autoEdit: false, // 决定了表格单元格是否在点击后立即进入编辑模式，即双击进入编辑
    excelCopyBufferOptions: {
      ...props.gridOptions.excelCopyBufferOptions,
      onBeforePasteCell: (e, args) => {
        const grid = args.grid
        const curOptions = grid.getOptions();
        if (curOptions.editable) {
          return true
        }
        // 返回 false 将阻止粘贴操作
        console.log("onBeforePasteCell", curOptions.editable)
        return false;
      }
    },
    enableEmptyDataWarningMessage: true, // 启用空数据提示
    emptyDataWarning: {
      message: '没有数据可显示', // 自定义空数据提示文案
      // 可选：自定义样式
      messageKey: '暂无数据'
      // className: 'custom-empty-warning', // 自定义 CSS 类
    }
  }
  if (disabled) {
    gridOptions.editable = false
    // gridOptions.enableCellNavigation = false
    gridOptions.autoEdit = false
    gridOptions.autoCommitEdit = false
    // gridOptions.enableExcelCopyBuffer = false
  }

  // 禁止编辑状态也下禁止粘贴
  // console.log("gridOptions.editable", gridOptions.editable, gridOptions.excelCopyBufferOptions)
  // if (gridOptions.editable === false) {
  //   gridOptions.excelCopyBufferOptions = {
  //     ...gridOptions.excelCopyBufferOptions,
  //     readOnlyMode: true
  //   }
  // } else {
  //   gridOptions.excelCopyBufferOptions = {
  //     ...gridOptions.excelCopyBufferOptions,
  //     readOnlyMode: false
  //   }
  // }


  // 向上移动。不考虑树形
  const moveUp = () => {
    if (!reactGridRef.current?.dataView) return;
    const selectedRows = reactGridRef.current?.slickGrid.getSelectedRows();
    const curRow = selectedRows[0]
    if (curRow > 0) {
      const item = reactGridRef.current?.dataView.getItem(curRow);
      console.log("item", item)
      if (item.__hasChildren) {
        message.warning("只能移动叶子节点")
        return;
      }
      reactGridRef.current?.dataView.deleteItem(item.id);
      reactGridRef.current?.dataView.insertItem(curRow - 1, item);
      // reactGridObjRef.current?.setSelectedRows([curRow - 1])
      // setActiveRowIndex(stateRef.current.activeRowIndex - 1)
    } else {
      message.warning("已经到顶了")
    }
  }

  // 向下移动。不考虑树形
  const moveDown = () => {
    if (!reactGridRef.current?.dataView) return;
    const selectedRows = reactGridRef.current?.slickGrid.getSelectedRows();
    const curRow = selectedRows[0]
    if (curRow < reactGridRef.current?.dataView?.getLength() - 1) {
      const item = reactGridRef.current?.dataView.getItem(curRow);
      if (item.__hasChildren) {
        message.warning("只能移动叶子节点")
        return;
      }
      reactGridRef.current?.dataView.deleteItem(item.id);
      reactGridRef.current?.dataView.insertItem(curRow + 1, item);
      reactGridObjRef.current?.setSelectedRows([curRow + 1])
      setActiveRowIndex(curRow + 1)
    }
  }

  // 删除行
  const deleteRow = () => {
    if (!reactGridRef.current?.dataView) return;
    const selectedRows = reactGridRef.current?.slickGrid.getSelectedRows();
    const curRow = selectedRows[0]
    const item = reactGridRef.current?.dataView.getItem(curRow);
    if (!item) {
      message.warning("请先选择一行")
      return;
    }
    Modal.confirm({
      title: `确定删除吗`,
      okText: '确认',
      cancelText: '取消',
      onOk() {
        reactGridRef.current?.dataView.deleteItem(item.id);
      },
      onCancel() { },
    })
  }
  // 移除行选中
  const removeRowSelected = () => {
    setActiveRowIndex(null) // 移除高亮行
    $(`#${gridId} .slick-cell`)?.removeClass("selected");
    $(`#${gridId} .slick-cell`)?.removeClass("slickgrid-selected");
    reactGridRef.current.slickGrid?.setSelectedRows([])
  }

  // 表格头click
  const handleTableHeaderClick = (e: CustomEvent<{ eventData: any; args: OnHeaderClickEventArgs; }>) => {
    const { eventData, args } = e.detail?.eventData;
    if (args.column.id) {
      const columnIndex = reactGridRef.current?.slickGrid.getColumnIndex(args.column.id);
      removeRowSelected()
      setActiveColumn(columnIndex)
      selectColumn(columnIndex)
      // 高亮列头
      $(`#${gridId} .slick-header-column`)?.removeClass('active');
      $(`#${gridId} div[data-id="${args.column.id}"].slick-header-column`)?.addClass('active');
    }
    props?.onHeaderClick?.(e)
  }

  // 选中列
  function selectColumn(columnIndex) {
    // 获取网格中的所有数据
    const data = reactGridRef.current?.dataView.getItems() || [];
    // 遍历所有行并选中指定列的单元格
    for (let i = 0; i < data.length; i++) {
      // 获取当前行的单元格
      const cell = reactGridRef.current?.slickGrid.getCellNode(i, columnIndex);
      // 如果单元格存在，则进行选中操作（例如添加CSS类）
      if (cell) {
        cell.classList.add('selected');
        cell.classList.add('slickgrid-selected');
      }
    }
  }

  // 视口滚动
  const handleViewPortChanged = throttle((e: CustomEvent<{ eventData: any; args: { grid: SlickGrid; }; }>) => {
    props.onViewportChanged?.(e)
    const activeColumn = stateRef.current.activeColumn
    console.log("activeColumn", activeColumn)
    if (!activeColumn) return;
    setActiveColumn(activeColumn)
    selectColumn(activeColumn)
  }, 200)

  const reactGrid1Ready = (e: CustomEvent<any>) => {
    const reactGrid: SlickgridReactInstance = e.detail;
    reactGridRef.current = reactGrid
    reactGridObjRef.current = reactGrid && reactGrid.slickGrid;
    reactGridDataviewRef.current = reactGrid && reactGrid.dataView;
    // 禁止粘贴事件
    // e.detail.element.subscribe((e: any, args: any) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    // });

    e.detail.element.addEventListener('paste', (e: ClipboardEvent) => {
      const curOptions = reactGrid.slickGrid.getOptions();
      if (!curOptions.editable) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
    // console.log("reactGrid1Ready", e)
    props?.onReactGridCreated?.(e)


  }

  // 设置树形展开图标
  const setupTreeExpandIcon = () => {
    if (!reactGridRef.current || !treeExpandColumn) return;
    // 查找展开列
    const columns = reactGridRef.current.slickGrid.getColumns();
    const expandColumn = columns.find(col => col.id === treeExpandColumn);

    if (!expandColumn) return;

    // 修改列标题，添加展开图标
    const columnHeader = document.querySelector(`#${gridId} div[data-id="${treeExpandColumn}"].slick-header-column .slick-column-name`);
    if (!columnHeader) return;
    // 判断是否已经设置了 展开图标
    if (columnHeader.querySelector('.slg-header-arrow')) return;
    console.log("innerHTML exec")
    columnHeader.innerHTML = `<div class="slg-column-header">
                <span>${expandColumn.name}</span>
                <span class="slg-header-arrow"> ${ReactDOMServer.renderToStaticMarkup(<ExpandIcon />)}</span>
           </div>`

    const headerArrow = document.querySelector(`#${gridId} div[data-id="${treeExpandColumn}"].slick-header-column .slg-header-arrow`);
    if (headerArrow) {
      // 添加展开图标
      const expandIconHtml = ReactDOMServer.renderToString(<ExpandIcon />);
      headerArrow.innerHTML = expandIconHtml;

      let dropdownMenu = null;
      let hideTimeout = null;

      // 创建下拉菜单
      function createDropdownMenu() {
        if (dropdownMenu) return;

        dropdownMenu = document.createElement("ul");
        dropdownMenu.classList.add("slg-dropdown-menu");

        // 添加展开全部选项
        const expandAllItem = document.createElement("li");
        expandAllItem.textContent = "展开全部";
        expandAllItem.addEventListener("click", () => {
          expandTree(expandAllLevel);
        });
        dropdownMenu.appendChild(expandAllItem);

        // 添加层级选项
        treeLevels.forEach(level => {
          const li = document.createElement("li");
          li.textContent = level.label;
          li.addEventListener("click", () => {
            expandTree(level.key);
          });
          dropdownMenu.appendChild(li);
        });

        // 添加收起全部选项
        const collapseAllItem = document.createElement("li");
        collapseAllItem.textContent = "收起全部";
        collapseAllItem.addEventListener("click", () => {
          expandTree('all');
        });
        dropdownMenu.appendChild(collapseAllItem);

        document.body.appendChild(dropdownMenu);

        dropdownMenu.addEventListener("mouseenter", () => {
          clearTimeout(hideTimeout);
        });

        dropdownMenu.addEventListener("mouseleave", hideDropdown);
      }

      function showDropdown(event) {
        clearTimeout(hideTimeout);
        createDropdownMenu();

        const rect = event.target.getBoundingClientRect();
        dropdownMenu.style.top = `${rect.bottom + window.scrollY}px`;
        dropdownMenu.style.left = `${rect.left + window.scrollX}px`;
        dropdownMenu.style.display = "block";
      }

      function hideDropdown() {
        if (dropdownMenu) {
          dropdownMenu.remove();
          dropdownMenu = null;
        }
      }

      // 绑定事件
      headerArrow.addEventListener("mouseenter", showDropdown);
      headerArrow.addEventListener("mouseleave", () => {
        hideTimeout = setTimeout(hideDropdown, 200);
      });
    }
  }

  // 表格排序
  const handleTableBeforeSort = (e: CustomEvent<{ eventData: any; args: SingleColumnSort; }>) => {
    return false
  }

  // 行选中 样式
  const selectRowStyle = () => {
    const activeRow = getActiveRowIndex()
    // console.log("selectRowStyle", isNumeric(0), { activeRow, gridId })
    if (isNumeric(activeRow)) {
      // 清除行选中
      const cell = reactGridRef.current?.slickGrid.getCellNode(activeRow, 0);
      // 如果已经是 selected，就不再处理
      if ($(cell).hasClass('selected')) return;
      $(`#${gridId} .slick-cell`).removeClass('active selected slickgrid-selected');
      $(cell).addClass('active selected slickgrid-selected').siblings().addClass('selected slickgrid-selected');

    }
  }

  // 清除列选中样式
  const clearColumnSelectedStyle = () => {
    // $(`#${gridId} .slick-header-column`).removeClass('active slickgrid-selected');
  }

  // 表格click，不包括表头
  const handleTableBodyClick = (e: CustomEvent<{ eventData: any; args: OnClickEventArgs; }>) => {
    console.log("tableClick22", e)
    const detail = e.detail;
    const args = detail?.args;
    const eventData = detail?.eventData;
    clearColumnSelectedStyle() // 清空列选中。列头不触发TableClick
    setActiveColumn(null) // 清除列选中数据
    // const eventData = detail?.eventData;
    // const targetDom = eventData?.target as HTMLElement;
    if (args?.cell === 0) {
      // setTimeout(() => {


      // 清除列选中
      // setActiveColumn(null)
      // setActiveRowIndex(args?.row)
      // selectRowStyle()

      const isCell = reactGridRef.current.slickGrid.getSelectionModel() instanceof SlickCellSelectionModel;
      if (isCell) {
        reactGridRef.current.slickGrid.setSelectionModel(new SlickRowSelectionModel());
      }
      reactGridRef.current.slickGrid.invalidate();

      // }, 300);
      // setTimeout(() => {
      //     $('.slick-cell').removeClass('active selected');
      //     $(targetDom).addClass('active selected').siblings().addClass('selected');
      // }, 0);
    } else {
      // removeRowSelected()
      // const curOptions = reactGridRef.current.slickGrid.getOptions();
      // console.log('curOptions', curOptions)

      const isCell = reactGridRef.current.slickGrid.getSelectionModel() instanceof SlickRowSelectionModel;
      if (isCell) {
        console.log("SlickRowSelectionModel2")
        reactGridRef.current.slickGrid.setSelectionModel(new SlickCellSelectionModel());
        reactGridRef.current.slickGrid.invalidate();
      }
      // if (!disabled) {
      //   removeRowSelected()
      // }
      // props?.onClick?.(e)
    }

    // if (disabled) {
    //   eventData?.event?.stopPropagation()
    //   // 事件默认行为
    //   eventData?.event?.preventDefault()
    //   return;
    // };
    props?.onClick?.(e)
  }

  // 设置
  const setCellDisabledStyle = ({ row, name, key }: { row: string | number, name: string, key: string }) => {
    const cssStyleHash = {
      [row]: { [name]: SlickgridEditDisabledClassName }, // 第二行的 "name" 列应用 'highlight-cell' 样式
    };
    reactGridRef.current.slickGrid.setCellCssStyles(key, cssStyleHash);
  }


  const pageLoading = useMemo(() => {
    if (warpSize?.width < 10) return true // 适配 drawer
    return loading
  }, [loading, warpSize?.width])


  // 展开
  const expandTree = (level: any) => {
    console.log("level", level)
    const allItems = reactGridRef.current.dataView.getItems()
    if (level == 'all') { // 收起全部
      reactGridRef.current?.treeDataService.toggleTreeDataCollapse(true);
    }
    let exLevels = []
    if (level >= 1) {
      for (let i = 1; i <= level; i++) {
        exLevels.push(i - 1 + '')
      }
    }
    traverseTree(allItems, node => {
      if (level == 0) { // 展开全部
        node.__collapsed = false
      }

      if (level >= 1) {
        node.__collapsed = !exLevels.includes(String(node.__treeLevel))
      }

    })
    reactGridRef.current.dataView.setItems(allItems)
  }

  // 处理树节点展开事件
  const handleTreeExpand = async (e: CustomEvent<{
    fromItemId: string;
    previousFullToggleType: string;
    toggledItems: Array<{
      isCollapsed: boolean;
      itemId: string;
    }>;
    type: 'toggle-collapse' | 'toggle-expand';
  }>) => {
    const { toggledItems, type, fromItemId } = e.detail;

    console.log('Tree expand event:', {
      type,
      toggledItems,
      detail: e.detail
    });
    // 只处理展开操作
    if (type !== 'toggle-expand' || toggledItems.length === 0) return;
    const lastNode = toggledItems.find(i => i.itemId == fromItemId)
    if (!lastNode) return;
    const { itemId, isCollapsed } = lastNode;
    const dataView = reactGridRef.current?.dataView;
    if (!dataView) return;

    const item = dataView.getItemById(itemId);

    // 添加调试日志
    console.log('Tree node status:', {
      itemId,
      item,
      hasLoadChildren: !!loadChildren,
      isLoaded: item?.__loadedChildren,
      isLoading: item ? stateRef.current.loadingNodes.has(itemId) : false,
      children: item?.children,
      collapsed: item?.__collapsed,
      treeLevel: item?.__treeLevel,
      isCollapsed
    });

    // 如果节点已经加载过子节点，只需要切换展开状态
    if (item?.__loadedChildren) {
      item.__collapsed = !item.__collapsed;
      dataView.updateItem(itemId, item);
      dataView.refresh();
      reactGridRef.current?.slickGrid.invalidate();
      reactGridRef.current?.slickGrid.render();
      return;
    }

    if (!item || !loadChildren || stateRef.current.loadingNodes.has(itemId)) {
      console.log('Skip loading children because:', {
        noItem: !item,
        noLoadChildren: !loadChildren,
        currentlyLoading: item ? stateRef.current.loadingNodes.has(itemId) : false,
        itemData: item
      });
      return;
    }

    try {
      // 显示加载状态
      stateRef.current.loadingNodes.add(itemId);
      item.__loading = true;
      const row = dataView.getRowById(itemId);
      reactGridRef.current?.slickGrid.invalidateRow(row);
      reactGridRef.current?.slickGrid.render();

      // 调用接口获取子节点数据
      const children = await loadChildren(item);
      console.log('Loaded children:', children);

      // 更新数据
      item.children = children;
      item.__loadedChildren = true;
      item.__loading = false;
      item.__collapsed = false;
      stateRef.current.loadingNodes.delete(itemId);

      // 刷新视图
      dataView.updateItem(itemId, item);

      // 确保所有子节点都被添加到DataView中
      if (Array.isArray(children)) {
        children.forEach(child => {
          // 设置子节点的树形属性
          child.__parentId = itemId;
          child.__treeLevel = (item.__treeLevel || 0) + 1;
          child.__hasChildren = false; // 默认设置为false，除非后续加载证明有子节点
          child.__collapsed = true;

          if (!dataView.getItemById(child.id)) {
            dataView.addItem(child);
          }
        });
      }

      // 强制刷新数据视图
      dataView.refresh();
      dataView.sort((a, b) => 0); // 触发重新排序以更新视图
      reactGridRef.current?.slickGrid.invalidate();
      reactGridRef.current?.slickGrid.render();

      console.log('After update:', {
        itemUpdated: dataView.getItemById(itemId),
        allItems: dataView.getItems(),
        visibleRows: reactGridRef.current?.slickGrid.getRenderedRange()
      });
    } catch (error) {
      console.error('Failed to load children:', error);
      item.__loading = false;
      stateRef.current.loadingNodes.delete(itemId);
      const row = dataView.getRowById(itemId);
      reactGridRef.current?.slickGrid.invalidateRow(row);
      reactGridRef.current?.slickGrid.render();
    }
  }

  useImperativeHandle(ref, () => {
    return {
      reactGridInstance: reactGridRef.current,
      getReactGridInstance: () => reactGridRef.current,
      getActiveRowIndex: () => {
        return stateRef.current.activeRowIndex
      },
      setActiveColumn,
      removeRowSelected,
      setActiveRowIndex,
      moveUp,
      moveDown,
      deleteRow,
      expandTree,
      setCellDisabledStyle
    }
  }, [])

  // useMount(() => {
  //   console.log("mount...")
  //   i18next.changeLanguage('zh');
  // })

  // resize with 表格
  // const resizeTable = debounce(() => {
  //   // const tableHeight = props.gridOptions?.gridHeight || 100;
  //   // reactGridRef.current?.resizerService.resizeGrid(0, { height: tableHeight, width: '100%' });
  //   reactGridRef.current?.resizerService.resizeGrid(0, { width: '100%' });
  // }, 500)


  const handleTalbeRender = (e: CustomEvent<{ eventData: any; args: OnRenderedEventArgs; }>) => {
    props?.onRendered?.(e)
    if (treeExpandColumn) {
      setupTreeExpandIcon();
    }
    // 还需要渲染 当前行
    // NOTE: 应该直接改源码会好一些，这样写容易出问题
    // console.log("renderId", gridId)
    selectRowStyle()
  }

  useWhyDidYouUpdate('useWhyDidYouUpdateComponent', { ...props, });
  // return <div ref={tableWrapRef} className={styles['tableWrap']}>
  return <div className={styles['tableWrap']}>
    {(props.gridOptions && !pageLoading) ?
      <Translation>
        {
          t => <SlickgridReact
            {...props}
            onHeaderClick={handleTableHeaderClick}
            gridOptions={gridOptions}
            onBeforeSort={handleTableBeforeSort}
            onViewportChanged={handleViewPortChanged}
            onClick={handleTableBodyClick}
            onReactGridCreated={reactGrid1Ready}
            onRendered={handleTalbeRender}
          // onTreeItemToggled={handleTreeExpand}
          />
        }
      </Translation> : null}

    {showLoading ? <div className={clsx(pageLoading ? '' : 'z-index--1', styles['spin'])}>
      <Spin spinning={loading}> </Spin>
    </div> : null}
  </div>
})
function shouldMemo(prevProps, nextProps) {
  /*
  如果把 nextProps 传入 render 方法的返回结果与
  将 prevProps 传入 render 方法的返回结果一致则返回 true，
  否则返回 false
  */

  // console.log("prevProps.columnDefinitions", prevProps.dataset === nextProps.dataset)
  const result = (prevProps.loading === nextProps.loading)
    && (prevProps.dataset === nextProps.dataset)
    && (prevProps.datasetHierarchical === nextProps.datasetHierarchical)
    && (prevProps.columnDefinitions?.map(i => (i.id + i.cssClass))?.join('') === nextProps.columnDefinitions?.map(i => (i.id + i.cssClass))?.join(''))
  // console.log("shouldMemo", prevProps.columnDefinitions, nextProps.columnDefinitions, (prevProps.columnDefinitions?.map(i => i.id)?.join('') === nextProps.columnDefinitions?.map(i => i.id)?.join('')))
  return result
}
export default React.memo(SlickGridComponent, shouldMemo)
// export default SlickGridComponent
